import axiosInstance from 'axiosInstance';

// ── Public waitlist endpoints ───────────────────────────

export const submitWaitlistApplication = async (payload) => {
  const response = await axiosInstance.post('waitlist/submit', payload);
  return response.data;
};

export const checkWaitlistStatus = async (email) => {
  const response = await axiosInstance.post('waitlist/status', { email });
  return response.data;
};

export const editWaitlistApplication = async (payload) => {
  const response = await axiosInstance.post('waitlist/edit', payload);
  return response.data;
};
